export default "__VITE_ASSET__29EJdSKO__"